import { useObserver } from 'mobx-react';
import { Route, withRouter, useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState, useMemo } from 'react';
import vm from './RefundListVm';
import PageNav from '@commonComponents/PageNav/PageNav';
import st from './RefundList.module.scss';
import clsx from 'clsx';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import BusinessName from '@pages/GridCommon/BusinessName/BusinessName';
import gridLocale from '@common/module/gridLocale.ko.js';
import queryString from 'query-string';
import RowNumberRenderer from '@pages/GridCommon/RowNumberRenderer/RowNumberRenderer';
import ProcessBtnRenderer from './ProcessBtnRenderer/ProcessBtnRenderer';
import {LicenseManager} from "ag-grid-enterprise";
LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-048028 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( standbylab )_is_granted_a_( Multiple Applications )_Developer_License_for_( 1 ))_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 19 September 2024 )____[v2]_MTcyNjcwMDQwMDAwMA==ddf0238f8ac3458090061890759fab84");

function RefundList() {
    const gridRef = useRef(); 
    let location = useLocation();
    const activeTab = queryString.parse(location.search).type;
    
    useEffect(() => {
        vm.load();
        vm.state.activeTab = activeTab || null;
    }, [activeTab])

    return useObserver(() => (
        <>
            <PageNav nav={["환급신청"]}/>
                <div className={st.gridContent}>
                    <ul className={st.tab}>
                        {vm.tabs.map((tab, index) => (
                            <li key={index} className={tab.taxRefundGridTabType === vm.state.activeTab ? st.active : null} onClick={() => vm.onTab(tab.taxRefundGridTabType)}>{tab.name}({tab.count})</li>
                        ))}
                    </ul>
                    {vm.columns.length !== 0 && 
                        <>
                            <Grid gridRef={gridRef} activeTab={vm.state.activeTab} key={activeTab}/>
                            <div className={st.gridPageSize}>
                                <span className={st.title}>Page Size</span> 
                                <select onChange={(e) => vm.onGridPageSizeChanged(e, gridRef)} defaultValue={"30"} className={st.selectedSmall}>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </>
                    }
                </div>
        </>
    ));
}
const Grid = React.memo(function (props) {
    const defaultColDef = useMemo(() => ({
        sortable: true,
        floatingFilter: true,
        resizable: true,
        cellEditorPopup : true
    }));
    const components = useMemo(() => ({
        "BusinessNameRenderer" : BusinessName,
        "RowNumberRenderer" : RowNumberRenderer,
        "ProcessBtnRenderer" : ProcessBtnRenderer
    }), [])
    return useObserver(() => (
        <div className={clsx(st.grid, "ag-theme-alpine")}>
            <AgGridReact pagination={true} paginationPageSize={30} rowSelection={'multiple'} cacheBlockSize={30} ref={props.gridRef} localeText={gridLocale} components={components} columnDefs={vm.columns} defaultColDef={defaultColDef} rowModelType={'serverSide'} serverSideDatasource={vm.gridData()} suppressBrowserResizeObserver={true} onCellEditingStopped={vm.onChangeData}/>
        </div>
    ));
})
export default RefundList;